module.exports = __webpack_public_path__ + "img/ask.4aca87e7.svg";